import Skeleton from "react-loading-skeleton";

import Box from "ds/components/Box";
import Card from "ds/components/Card";

import styles from "./styles.module.css";

const AssistantPanelLearnActiveGuideViewSkeleton = () => (
  <Box direction="column" gap="large" grow="1" padding="x-large" overflowHidden>
    <Box align="center" justify="between" fullWidth gap="medium">
      <Box align="center" gap="small" className={styles.guideTitle} padding="small">
        <Skeleton width={20} height={20} borderRadius={4} />
        <Skeleton width={150} height={16} borderRadius={4} />
      </Box>

      <Box grow="1" align="center" gap="medium" className={styles.progressBar}>
        <Skeleton width="100%" height={8} borderRadius={4} />
      </Box>
    </Box>

    <Card contentGap="large" className={styles.card}>
      <Skeleton width={200} height={20} borderRadius={4} />
      <Skeleton count={3} height={16} borderRadius={4} />
      <Box direction="row" gap="medium" align="center">
        <Skeleton width={80} height={32} borderRadius={4} />
        <Skeleton width={100} height={32} borderRadius={4} />
      </Box>
    </Card>
  </Box>
);

export default AssistantPanelLearnActiveGuideViewSkeleton;
